export const QueryServerKeys = {
  ROLES: {
    GET_ROLES: 'roles',
  },
  ACCOUNT_TYPES: {
    GET_USER_ACCOUNT_TYPES: 'user-account-types',
  },
  USER_ROLES: {
    GET_USER_ROLES: 'user-roles',
    GET_USER_ROLE_BY_ID: 'user-role-by-id',
    CREATE_USER_ROLE: 'create-user-role',
  },
  ADMIN_ACCESS: {
    CATALOG: 'admin-permission-catalog',
    USER_ACCESS: 'user-admin-access',
  },
  USER: {
    GET_USER_DATA: 'me',
    ACCESS: 'me-access',
    GET_USERS: 'get-users',
    GET_DEPARTMENTS: 'get-departments',
    GET_DEPARTMENT_RECORDS: 'get-department-records',
    GET_TEAMS: 'get-teams',
    CONSUMPTION_INFO_KEY: 'consumption-info-list',
    UPDATE_USER: 'update-user',
    PERMISSIONS: 'get-user-permissions',
    EMAIL_SEARCH: 'user-email-search',
  },
  HOME: {
    GET_INFO: 'home-info',
  },
  INSTANCE: {
    GET_INSTANCE_SCHEMA: 'instance-schema',
  },
  CLUSTER_MANAGEMENT: {
    CLUSTER_BY_NAME: 'cluster-by-name',
    CLUSTERS: 'get-clusters',
    RESTORED_CLUSTERS: 'get-restored-clusters',
    UPDATE_CLUSTER: 'update-cluster',
    UPDATE_AUTO_SCALING: 'update-auto-scaling',
    SYNC_PYTHON_PACKAGES: 'sync-python-packages',
    CLUSTER_DETAILS: 'cluster-details',
    AUTO_SUSPEND_HISTORY: 'auto-suspend-history',
    SPARK_IMAGES_SIZES: 'spark-images-sizes',
    CONSUMPTION_BURN: 'cluster-consumption-burn',
    AI_USAGE: 'cluster-ai-usage',
    COPILOT_AUDIT_USAGE: 'cluster-copilot-audit-usage',
    OS_MEMORY: 'cluster-os-memory',
    HEAP_MEMORY: 'cluster-heap-memory',
    APP_SERVICE_SIZING: 'cluster-app-service-sizing',
  },
  N8N_EXECUTIONS: {
    LIST: 'n8n-executions-list',
    DETAILS: 'n8n-execution-details',
  },
  CLUSTER_CUSTOMIZATION: {
    CUSTOMIZATION_LIST: 'customization-list',
    CUSTOMIZE_CLUSTER: 'customize-cluster',
    UPDATE_CLUSTER_SLA: 'update-cluster-sla',
  },
  MAXIMUM_IPU: {
    GET_MAXMIMUM_IPU: 'get-maximum-ipu',
  },
  SPARK: {
    IMAGES: 'images',
  },
  PROVISION_CUSTOMER: {
    PROVISION_OPTIONS: 'provision-options',
    CREATE_ACCOUNT: 'create-account',
  },
  CAPACITY_MANAGEMENT: {
    CLOUD_PROVIDERS: 'cloud-providers',
    CLUSTER_SIZES_PER_PROVIDER: 'cluster-sizes-per-provider',
    CLUSTER_SIZE_OPERATORS_PER_PROVIDER: 'cluster-size-operators-per-provider',
    CLUSTER_SIZE_ROLES: 'cluster-size-roles',
    CLUSTER_SIZE_OPERATORS_PER_CLUSTER_CODE:
      'cluster-size-operators-per-cluster-code',
    NODE_LABELS: 'node-labels',
    CREATE_NEW_CLUSTER_SIZE: 'create-new-cluster-size',
    AFFECTED_CLUSTERS: 'affected-clusters',
    UPDATE_CLUSTER_SIZE: 'update-cluster-size',
    DELETE_CLUSTER_SIZE: 'delete-cluster-size',
    CLUSTER_SIZES_FOR_USER_ROLE_PLATFORM_OPERATOTR:
      'cluster-sizes-for-user-role-platform-operator',
    CMC_SIZES: 'cmc-sizes',
  },
  BLUEPRINT: {
    BLUEPRINT_LIST: 'blueprint-list',
  },
  CLUSTER_MONITORING: {
    GET_PROGRESS_LOGS: 'get-progress-logs',
    DOWNLOAD_PROGRESS_LOGS: 'download-progress-logs',
    GET_PAGINATED_PROGRESS_LOGS: 'get-paginated-progress-logs',
    GET_CONSUMPTION_ARCHIVE_FILES: 'get-consumption-archive-files',
    DOWNLOAD_CONSUMPTION_ARCHIVE_FILE: 'download-consumption-archive-file',
    GET_SERVICE_METRICS: 'get-service-metrics',
    GET_AUDIT_ARCHIVE_FILES: 'get-audit-archive-files',
    DOWNLOAD_AUDIT_ARCHIVE_FILE: 'download-audit-archive-file',
    GET_ARCHIVED_LOGS: 'get-archived-logs',
    DOWNLOAD_ARCHIVED_LOG: 'download-archived-log',
    PREVIEW_ARCHIVED_LOG: 'preview-archived-log',
    GET_COMPONENT_LOGS: 'get-component-logs',
    DOWNLOAD_COMPONENT_LOGS: 'download-component-logs',
    GET_COMPONENT_PODS: 'get-component-pods',
  },
  SYSTEM_MANAGEMENT: {
    CONFIGURATIONS: 'configurations',
    CREATE_CONFIGURATIONS: 'create-configurations',
    UPDATE_CONFIGURATIONS: 'update-configurations',
    PLATFORM_ACTIONS: 'platform-actions',
    UPDATE_PLATFORM_ACTION: 'update-platform-action',
    PLATFORMS_LIST: 'platforms-list',
    PLATFORM_ACTIONS_BY_CODE: 'platform-actions-by-code',
    ROLE_CAPABILITIES: 'role-capabilities',
    UPDATE_PLATFORM_ACTION_MAPPING: 'update-platform-action-mapping',
    UPDATE_ROLE_PLATFORM: 'update-role-platform',
    UPDATE_ROLE_ACTION: 'update-role-action',
    AZURE_PLANS: 'azure-plans',
    ADD_USER_TO_FEATURE: 'add-user-to-feature',
    TOGGLE_FEATURES: 'toggle-features',
  },
  CHIDORI: {
    CHIDORI: 'get-chidori',
    GET_SIZES: 'get-chidori-sizes',
    UPDATE_SIZES: 'update-chidori-sizes',
    EXPOSE_CHIDORI_CREDENTIALS: 'expose-chidori-credentials',
    DISABLE_CHIDORI_PUBLIC_API: 'disable-chidori-public-api',
    UPGRADE: 'upgrade',
    RESTART: 'restart-chidori',
    MEMORY: 'chidori-memory-limit',
    STATUS: 'chidori-status',
  },
  NOTIFICATION: {
    INSTANCE_USERS: 'get-notification-instance-users',
    ADD_GLOBAL_NOTIFICATION: 'add-global-notification',
  },
  OPERATORS: {
    GET_OPERATORS: 'get-operators',
  },
  SLA_TYPE: {
    GET_SLA_TYPE: 'get-sla-type',
  },
  INCORTA_VERSIONS: {
    GET_INCORTA_VERSIONS: 'get-incorta-versions',
  },
  FEATURE_BITS: {
    GET_FEATURE_BITS: 'get-feature-bits',
  },
  SCHEDULED_SCALING: {
    GET_SCALING: 'get-scalings',
    ADD_SCALING: 'add-scalings',
    DELETE_SCALING: 'delete-scaling',
    PAUSE_SCALING: 'pause-scaling',
    RESUME_SCALING: 'resume-scaling',
  },
  SERVICES_SCALING: {
    GET_SERVICES_STATUS: 'get-services-status',
    CLUSTER_LIST_KEY: 'cluster-list',
    CLUSTER_SIZE_TYPES_KEY: 'cluster-size-types',
    SCALE_CLUSTER: 'scale_cluster',
    CONNECT_SUB_CLUSTER: 'connect-sub-cluster',
    DELETE_SUB_CLUSTER: 'delete-sub-cluster',
    DISCONNECT_SUB_CLUSTER: 'disconnect-sub-cluster',
    GET_SCALING_NODES: 'get-scaling-nodes',
  },
  COST_TYPE: {
    GET_COST_TYPE: 'get-cost-type',
  },
  NOTEBOOK: {
    GET_NOTEBOOK_USERS_CONFIGS: 'get-notebook-users-configs',
    UPDATE_NOTEBOOK_USERS_CONFIGS: 'update-notebook-users-configs',
    UPDATE_NOTEBOOK: 'update-notebook',
  },
  PARTNERS: {
    GET_PARTNERS: 'get-partners',
    DELETE_PARTNER: 'delete-partner',
    CREATE_PARTNER_CLUSTER: 'create-partner-cluster',
    GET_PARTNER_CLUSTERS: 'get-partner-clusters',
  },
  CONSUMTION: {
    GET_CONSUMTION: 'get-consumtions',
    UPDATE_CONSUMTION: 'update-consumtions',
  },
  EXTERNAL_BUCKET: {
    GET_INSTANCE_EXTERNAL_BUCKET_CONFIG: 'get-external-bucket',
    TOGGLE_EXTERNAL_BUCKET: 'toggle-external-bucket',
    SIMPLE_CLUSTER_SEARCH_FOR_EXTERNAL_BUCKET:
      'simple-cluster-search-for-external-bucket',
    ADD_CLUSTER_TO_EXTERNAL_BUCKET: 'add-cluster-to-external-bucket',
    REMOVE_CLUSTER_TO_EXTERNAL_BUCKET: 'remove-cluster-to-external-bucket',
    TOGGLE_EXTERNAL_BUCKET_DESTINATION_CLUSTER:
      'toggle-external-bucket-destination-cluster',
  },
  DATA_AGENT_NODE_SELECTOR: {
    GET_NODEPOOLS: 'get-data-agent-nodepools',
    UPDATE_NODE_SELECTOR: 'update-data-agent-node-selector',
  },
  CMC_PASSWORD: {
    GENERATE_PASSWORD: 'generate-password',
    CHANGE_PASSWORD: 'change-password',
  },
  LIBRARIES: {
    GET_LIBRARIES: 'get-libraries',
    UPLOAD_LIBRARY: 'upload-library',
    INSTALL_LIBRARIES: 'install-libraries',
    UNINSTALL_LIBRARIES: 'uninstall-libraries',
    UNINSTALL_MULTIPLE_LIBRARIES: 'uninstall-multiple-libraries',
    GET_UPLOAD_URL: 'get-upload-url',
  },
  CMC: {
    GET_CMC_SIZES: 'get-cmc-sizes',
    UPDATE_CMC_SIZES: 'update-cmc-sizes',
    GET_CMC_SIZES_FOR_INSTANCE: 'get-cmc-sizes-for-instance',
  },
  DEPLOYMENTS: {
    LIST: 'deployments-list',
    CREATE: 'deployments-create',
    DELETE: 'deployments-delete',
    DELETE_BULK: 'deployments-delete-bulk',
    SUBSCRIBE: 'deployments-subscribe',
    UNSUBSCRIBE: 'deployments-unsubscribe',
    GET_SUBSCRIBERS: 'deployments-get-subscribers',
  },
  WARMUP_NODES: {
    SEARCH_NODE_POOLS: 'search-node-pools',
    GET_WARMUP_BALLOONS: 'get-warmup-balloons',
  },
  FINOPS_FLEET: {
    FILTERS: 'finops-fleet-filters',
    CLUSTERS: 'finops-fleet-clusters',
    CLUSTER_IDS: 'finops-fleet-cluster-ids',
    DATA: 'finops-fleet-data',
    SELECTIONS: 'finops-fleet-selections',
    RECIPIENTS: 'finops-fleet-recipients',
    OWNERS: 'finops-fleet-owners',
    PERSON_DASHBOARDS: 'finops-fleet-person-dashboards',
  },
  CLI_TERMINAL: {
    SESSIONS: 'cli-terminal-sessions',
    SESSION: 'cli-terminal-session',
    COMMANDS: 'cli-terminal-commands',
    CATALOG: 'cli-terminal-catalog',
    TARGETS: 'cli-terminal-targets',
    AUTHENTICATE: 'cli-terminal-authenticate',
  },
  INFRA_MAP: {
    SETTINGS: 'infra-map-settings',
    CLUSTER: 'infra-map-cluster',
    CLUSTER_DECLARED: 'infra-map-cluster-declared',
    SERVICE_PODS: 'infra-map-service-pods',
    POD_PLACEMENT: 'infra-map-pod-placement',
    POD_CONTAINERS: 'infra-map-pod-containers',
    CLUSTER_VERSION: 'infra-map-cluster-version',
    CLUSTER_USAGE: 'infra-map-cluster-usage',
    CLUSTER_ALERTS: 'infra-map-cluster-alerts',
    CLUSTER_COST: 'infra-map-cluster-cost',
    CLUSTER_CHANGES: 'infra-map-cluster-changes',
    CLUSTER_INFRASTRUCTURE: 'infra-map-cluster-infrastructure',
    CLUSTER_SEARCH: 'infra-map-cluster-search',
    SUGGEST: 'infra-map-suggest',
  },
  USAGE_ALERTS: {
    LIST: 'usage-alerts-list',
    EVENTS: 'usage-alerts-events',
    FILTERS: 'usage-alerts-filters',
    CREATE: 'usage-alerts-create',
    UPDATE: 'usage-alerts-update',
    DELETE: 'usage-alerts-delete',
  },
};
